// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3eMWn","productName":"Table_productName__Ntzo0"};